export default {"src":"/inst/_next/static/media/whatsapp.fdc87b66.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};